import { FAQ_CATEGORIES } from '../../libs/faqs';

type ArticleSlug = string;

export interface GuideMeta {
  title: string;
  one_line_summary: string;
  categories: FAQ_CATEGORIES[];
  // Date in YYYY-MM-DD
  date: string;
}

type ArticleData = Record<ArticleSlug, GuideMeta>;

const articlesData: ArticleData = {
  'access-map-and-sequence-view': {
    date: '2026-03-28',
    title: 'Access Map and Sequence View',
    one_line_summary: 'How do I switch between map and sequence view?',
    categories: [FAQ_CATEGORIES.VIEW_AND_DISPLAY],
  },
  'accessing-teams-in-photo51': {
    date: '2026-03-28',
    title: 'Accessing Teams',
    one_line_summary: 'How do I access teams in Photo51?',
    categories: [FAQ_CATEGORIES.TEAM],
  },
  'accessing-the-photo51-cloud-application': {
    date: '2026-03-28',
    title: 'Accessing the Photo51 Cloud Application',
    one_line_summary: 'How do I access Photo51 from my browser?',
    categories: [FAQ_CATEGORIES.INSTALLATION_AND_ACCESS],
  },
  'adding-features': {
    date: '2026-03-28',
    title: 'Adding Features',
    one_line_summary: 'In order to add features, first navigate to the “Features” tab in the top banner, then select the “Add” button. This will open the “Add feature” modal box.',
    categories: [FAQ_CATEGORIES.FEATURES],
  },
  'adding-folders-and-organization': {
    date: '2026-03-28',
    title: 'Adding Folders and Organization',
    one_line_summary: 'In order to create a new folder, you need to access the “Library” tab in the top banner. Use the “New folder” button. This will open the folder creation modal box. Give the new folder a name and select “Create” to add the new folder to your library.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'adding-removing-editing-and-copying-primers': {
    date: '2026-03-28',
    title: 'Adding, Removing, Editing and Copying Primers',
    one_line_summary: 'All primer related features can be found under the “PCR” tab in the top banner. Once here you can find the “Add”, “Edit”, “Copy” and “Remove” buttons which are your main primer editing tools.',
    categories: [FAQ_CATEGORIES.PRIMERS],
  },
  'align-to-reference': {
    date: '2026-03-28',
    title: 'Align to Reference',
    one_line_summary: 'To align sequences to a reference sequence, start by navigating to the “Alignment” tab in the top banner. Select the “Align to reference” button and the alignment modal box will open.',
    categories: [FAQ_CATEGORIES.ALIGNMENT],
  },
  'annealing-oligos': {
    date: '2026-03-28',
    title: 'Annealing Oligos',
    one_line_summary: 'To start annealing oligonucleotides navigate to the “PCR” tab in the top banner and select “Anneal oligos”. Once selected the “Anneal oligos” modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'blat-read-sequences': {
    date: '2026-03-28',
    title: 'BLAT Read Sequences',
    one_line_summary: 'You can use the BLAST-Like Alignment Tool (BLAT) to find high-identity matches by indexing the genome, the tool is ideal for fast alignments and is typically faster than Basic Local Alignment Search Tool (BLAST) however is less sensitive to divergent sequences. (Kent, W. J. (2002). BLAT—the BLAST-like alignment tool. Genome research, 12(4), 656-664.)',
    categories: [FAQ_CATEGORIES.ALIGNMENT],
  },
  'bulk-importing-and-exporting-primers': {
    date: '2026-03-28',
    title: 'Bulk Importing and Exporting Primers',
    one_line_summary: 'To start bulk importing navigate to the “PCR” tab in the top banner and select the “Import” button. This will open the “Import primers” modal box. Notice the active tab by default is the “From Library” tab.',
    categories: [FAQ_CATEGORIES.PRIMERS, FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'bulk-importing-features': {
    date: '2026-03-28',
    title: 'Bulk Importing Features',
    one_line_summary: 'To get started open the file to which you want to import features. Then navigate to the “Features” tab in the top banner, find the “Import” button and click it to open the “Import features” modal box.',
    categories: [FAQ_CATEGORIES.FEATURES, FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'changing-your-password': {
    date: '2026-03-28',
    title: 'Changing your Password',
    one_line_summary: 'How do I change my password?',
    categories: [FAQ_CATEGORIES.ACCOUNT_MANAGEMENT],
  },
  'checking-logged-in-devices': {
    date: '2026-03-28',
    title: 'Checking Logged-in Devices',
    one_line_summary: 'How do I see which devices have logged into my account?',
    categories: [FAQ_CATEGORIES.ACCOUNT_MANAGEMENT],
  },
  'contig-assembly': {
    date: '2026-03-28',
    title: 'Contig Assembly',
    one_line_summary: '⚠️ Error: The file \'Contig Assembly.docx\' is corrupted.',
    categories: [FAQ_CATEGORIES.ALIGNMENT],
  },
  'copy-paste-and-cut': {
    date: '2026-03-28',
    title: 'Copy, Paste and Cut',
    one_line_summary: 'If you would like to copy or cut parts of your sequence, start by selecting the desired region either by dragging across the region, clicking on feature or using a keyboard shortcut. Then navigate to the “Edit” tab and find the “Cut” or “Copy” buttons in the top banner. Select “Cut” to copy the sequence to the clipboard and remove it from the current file. You can either insert the copied sequence by clicking a single point in the sequence and you can replace a given region with the copied sequence if you first select a region. You can then use the past button to paste the copied or cut sequence into a different region of the current sequence, into a different file or into a new sequence file by going to “File” &gt; “New sequence”.',
    categories: [FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'creating-and-pasting-new-sequences': {
    date: '2026-03-28',
    title: 'Creating and Pasting New Sequences',
    one_line_summary: 'In order to create a new file via copy pasting the sequence, you need to access the “Library” tab or the “File” tab in the top banner. In both menus you will see the button called “New sequence” when selected it will open the new files modal box.',
    categories: [FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'creating-custom-enzyme-lists': {
    date: '2026-03-28',
    title: 'Creating Custom Enzyme Lists',
    one_line_summary: 'There are two buttons to toggle the display options for enzymes called “Enzymes”. The first is under the “View” tab of the top banner, and the other can be found under the “Enzymes” tab, both of these function identically.',
    categories: [FAQ_CATEGORIES.ENZYMES],
  },
  'creating-editing-and-removing-guide-rnas': {
    date: '2026-03-28',
    title: 'Creating, Editing and Removing Guide RNAs',
    one_line_summary: 'In order to access the CRISPR-Cas features for designing and creating gRNAs, open a file and navigate to the “CRISPR” tab in the top banner. Note that the CRISPR-Cas features are only available in sequence view, this means you will need to use the bottom navigation bar and select “Sequence” as the default view is “Map” view. Once you have successfully navigated here the buttons in the top banner will no longer be grayed out.',
    categories: [FAQ_CATEGORIES.CRISPR],
  },
  'creating-teams': {
    date: '2026-03-28',
    title: 'Creating Teams',
    one_line_summary: 'How do I create a team in Photo51?',
    categories: [FAQ_CATEGORIES.TEAM],
  },
  'deleting-and-renaming': {
    date: '2026-03-28',
    title: 'Deleting and Renaming',
    one_line_summary: 'To get an overview of all your files and folders navigate to the “Library” tab in the top banner, this will show you the current teams library, by default this is your “My Files”.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'detecting-common-features': {
    date: '2026-03-28',
    title: 'Detecting Common Features',
    one_line_summary: 'Feature detection allows you to detect and annotate common features within your sequence. To get started navigate to the “Features” tab in the top banner. Find the “Detect common” button. Once clicked this will trigger the feature detection a small loading bar will display below the sequence to indicate progress.',
    categories: [FAQ_CATEGORIES.FEATURES],
  },
  'downloading-photo51-desktop-application': {
    date: '2026-03-28',
    title: 'Downloading Photo51 Desktop Application',
    one_line_summary: 'How do I access and install the Photo51 desktop application?',
    categories: [FAQ_CATEGORIES.INSTALLATION_AND_ACCESS],
  },
  'editing-and-removing-features': {
    date: '2026-03-28',
    title: 'Editing and Removing Features',
    one_line_summary: 'If you would like to edit an existing feature, navigate to either “Map” view, “Sequence” view, or the “Features” in the bottom navigation bar. Make sure in the top banner you have selected the “Features” tab. Then select and existing feature by clicking on it. Then you can use the “Edit” button in the “Features” tab. This will open the features modal window and let you make changes.',
    categories: [FAQ_CATEGORIES.FEATURES],
  },
  'enabling-two-factor-authentication': {
    date: '2026-03-28',
    title: 'Enabling Two-Factor Authentication',
    one_line_summary: 'How do I setup two factor authentication for Photo51?',
    categories: [FAQ_CATEGORIES.ACCOUNT_MANAGEMENT],
  },
  'enzyme-display': {
    date: '2026-03-28',
    title: 'Enzyme Display',
    one_line_summary: 'There are two buttons to toggle the display options for enzymes called “Enzymes”. The first is under the “View” tab of the top banner, and the other can be found under the “Enzymes” tab, both of these function identically.',
    categories: [FAQ_CATEGORIES.ENZYMES, FAQ_CATEGORIES.VIEW_AND_DISPLAY],
  },
  'exporting-files-and-images': {
    date: '2026-03-28',
    title: 'Exporting Files and Images',
    one_line_summary: 'Go to the “Library” or “File” tab in the top banner. The “Export” button in both tabs lets you export the file in “FASTA (.fasta)” or “GenBank (.gb)” formats. In the “Library” export you additionally have the option to export a CSV (.csv) of all the file’s metadata. In the library it is also possible to select and export multiple files at once, these will then be grouped and compressed in a .zip folder. The last option is to select one or more files and right click to get the right click dropdown, here you can select export options as well.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'features-and-orfs': {
    date: '2026-03-28',
    title: 'Features and ORFs',
    one_line_summary: 'If you wish to create features based on ORFs you first need to toggle on the ORF display. To do this navigate to the “Features” tab in the top banner and select “Display ORFs” you will see all ORFs displayed and the corresponding amino acid translations.',
    categories: [FAQ_CATEGORIES.FEATURES],
  },
  'files-versions-and-history': {
    date: '2026-03-28',
    title: 'Files Versions and History',
    one_line_summary: 'In order to see all previous versions of a given file, navigate to the “Library” tab, then select the desired file from the list. Once selected navigate to the top banner and use the “Versions” button to opening the versioning modal box. Alternatively, you can right click on the file and use the dropdown to select “Versions”.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'gateway': {
    date: '2026-03-28',
    title: 'Gateway',
    one_line_summary: 'In order to perform in-silico gateway cloning, start by navigating to the “Cloning” tab in the top banner. Then select the “Gateway cloning” dropdown menu, here you will see the option to select BP or LR gateway cloning. Select the appropriate method and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'genome-navigation': {
    date: '2026-03-28',
    title: 'Genome Navigation',
    one_line_summary: 'To select a specific chromosome to view, use the dropdown at the top right to select a chromosome.',
    categories: [FAQ_CATEGORIES.GENOME_BROWSER],
  },
  'gibson': {
    date: '2026-03-28',
    title: 'Gibson',
    one_line_summary: 'In order to perform in-silico Gibson assembly, start by navigating to the “Cloning” tab in the top banner. Then select the “Gibson assembly” button and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'golden-gate': {
    date: '2026-03-28',
    title: 'Golden Gate',
    one_line_summary: 'In order to perform in-silico Golden Gate cloning, start by navigating to the “Cloning” tab in the top banner. Then select the “Golden gate cloning” button and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'hifi': {
    date: '2026-03-28',
    title: 'HiFi',
    one_line_summary: 'In order to perform in-silico HiFi assembly, start by navigating to the “Cloning” tab in the top banner. Then select the “HiFi assembly” button and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'highlighting': {
    date: '2026-03-28',
    title: 'Highlighting',
    one_line_summary: 'It is only possible to highlight regions in the sequence view. Start by using the bottom navigation bar and selecting “Sequence” to take you into sequence view. Once here, navigate to the “Edit” menu in the top banner, you will see the highlight button on the right side of the banner.',
    categories: [FAQ_CATEGORIES.VIEW_AND_DISPLAY],
  },
  'importing-files-from-addgene': {
    date: '2026-03-28',
    title: 'Importing files from AddGene',
    one_line_summary: 'It is possible to access and import files directly from the AddGene database within the application. To access the AddGene search, navigate to the “Library” tab in the top banner. On the right side of the “Library” ribbon select the “addgene” button. This will activate the AddGene search bar.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'importing-files-into-teams': {
    date: '2026-03-28',
    title: 'Importing Files into Teams',
    one_line_summary: 'How do I import files into teams?',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION, FAQ_CATEGORIES.TEAM],
  },
  'infusion': {
    date: '2026-03-28',
    title: 'InFusion',
    one_line_summary: 'In order to perform in-silico InFusion cloning, start by navigating to the “Cloning” tab in the top banner. Then select the “InFusion cloning” button and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'library-search': {
    date: '2026-03-28',
    title: 'Library Search',
    one_line_summary: 'In order to search for files in your library, navigate to the “Library” tab and find the “Search” button on the right side.',
    categories: [FAQ_CATEGORIES.LIBRARY],
  },
  'loading-a-reference-genome-and-importing-tracks': {
    date: '2026-03-28',
    title: 'Loading a Reference Genome and Importing Tracks',
    one_line_summary: 'To start using the genome browser navigate to the “Genome” tab in the top ribbon. By default the genome browser uses the Human GRCh38 / hg38 genome as the reference genome and loads the Refseq Select and the Refseq Genes tracks.',
    categories: [FAQ_CATEGORIES.GENOME_BROWSER],
  },
  'managing-account-information': {
    date: '2026-03-28',
    title: 'Managing Account Information',
    one_line_summary: 'How do I edit my account information?',
    categories: [FAQ_CATEGORIES.ACCOUNT_MANAGEMENT],
  },
  'managing-team-members-and-permissions': {
    date: '2026-03-28',
    title: 'Managing Team Members and Permissions',
    one_line_summary: 'How do I manage team members and permissions?',
    categories: [FAQ_CATEGORIES.TEAM],
  },
  'managing-tracks': {
    date: '2026-03-28',
    title: 'Managing Tracks',
    one_line_summary: 'Tracks can be moved by using the grey grab bar on the right side of the track and dragging the track up and down to the desired position. To delete a track, select the gear icon next to the track and select “Remove track” from the dropdown.',
    categories: [FAQ_CATEGORIES.GENOME_BROWSER],
  },
  'modifying-dna-ends': {
    date: '2026-03-28',
    title: 'Modifying DNA Ends',
    one_line_summary: 'In order to modify DNA ends, you must have a linear sequence. To do this use the “Linearize” function found under the “Edit” tab of the top banner. Here you can linearize via restriction digest or PCR. Once you have linearized your sequence you are ready to modify the DNA ends.',
    categories: [FAQ_CATEGORIES.CLONING, FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'multiple-sequence-alignment': {
    date: '2026-03-28',
    title: 'Multiple Sequence Alignment',
    one_line_summary: 'To align multiple sequences to a consensus sequence using MUSCLE or MAFFT algorithms, start by navigating to the “Alignment” tab in the top banner. Select the “Multiple sequence alignment” button and the alignment modal box will open.',
    categories: [FAQ_CATEGORIES.ALIGNMENT],
  },
  'opening-files-from-your-device': {
    date: '2026-03-28',
    title: 'Opening Files from your Device',
    one_line_summary: 'To open / import files from your device, navigate to the “Library” tab in the top banner, then find the “Open” button and select it. This will open the importing modal. Here you can drag and drop new files in or click in the dotted rectangle to open your operating system’s file management.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'pairwise-alignment': {
    date: '2026-03-28',
    title: 'Pairwise Alignment',
    one_line_summary: 'To align two sequences using pairwise alignment, start by navigating to the “Alignment” tab in the top banner. Select the “Pairwise alignment” button and the alignment modal box will open.',
    categories: [FAQ_CATEGORIES.ALIGNMENT],
  },
  'pcr-mutagenic-pcr-and-automated-primer-design': {
    date: '2026-03-28',
    title: 'PCR, Mutagenic PCR and Automated Primer Design',
    one_line_summary: 'It is possible to simulate PCR and automatically have Photo51 design primers for your planned experiment. Start by navigating to the “PCR” tab in the top banner, here find and select the “PCR” button, this will open the PCR modal box.',
    categories: [FAQ_CATEGORIES.PRIMERS, FAQ_CATEGORIES.CLONING],
  },
  'restriction': {
    date: '2026-03-28',
    title: 'Restriction',
    one_line_summary: 'In order to perform in-silico HiFi assembly, start by navigating to the “Cloning” tab in the top banner. Then select the “Restriction cloning” button and the cloning modal will open.',
    categories: [FAQ_CATEGORIES.ENZYMES, FAQ_CATEGORIES.CLONING],
  },
  'reverse-complementing-the-sequence': {
    date: '2026-03-28',
    title: 'Reverse Complementing the Sequence',
    one_line_summary: 'It is possible to reverse complement your sequence via the “Reverse complement” button. This can be found under “View” &gt; “Reverse complement” or “Edit” &gt; “Reverse complement”. Once selecting the button, the sequence will immediately be reversed (flipped). Note that if you save, this change will be kept permanently.',
    categories: [FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'saving-sequences-and-exporting-images': {
    date: '2026-03-28',
    title: 'Saving Sequences and Exporting Images',
    one_line_summary: 'To save an image (SVG or PNG) of all displayed tracks, navigate to the “Export” button in the top banner, select the dropdown and select your desired image format. Note you can also export the FASTA sequence of the current in view region.',
    categories: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'sequence-topology-and-linearization': {
    date: '2026-03-28',
    title: 'Sequence Topology and Linearization',
    one_line_summary: 'If you would like to change a sequence from its current topology to another, navigate to the “Edit” tab in the top banner and find the “Topology” dropdown. You can select the dropdown and the current topology will be indicated via a checkmark next to the word “Circular” or “Linear”.',
    categories: [FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'sharing-saving-and-recent-files': {
    date: '2026-03-28',
    title: 'Sharing, Saving and Recent Files',
    one_line_summary: 'If you would like to share files with others you can use the share function. Navigate to the “Library” or “File” tab and select “Share” or “Share with users” respectively. This will open the “Share files with users” modal box. Here you can search for other users via the search bar, select recent users you interacted with or input the name and email of a collaborator not yet using Photo51.',
    categories: [FAQ_CATEGORIES.SHARING_FILES, FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'ta': {
    date: '2026-03-28',
    title: 'TA',
    one_line_summary: '⚠️ Error: The file \'Enzyme Tab _ MISSING.docx\' is corrupted.',
    categories: [FAQ_CATEGORIES.CLONING],
  },
  'team-subscriptions': {
    date: '2026-03-28',
    title: 'Team Subscriptions',
    one_line_summary: 'How do I get a team subscription for Photo51?',
    categories: [FAQ_CATEGORIES.SUBSCRIPTIONS, FAQ_CATEGORIES.TEAM],
  },
  'transferring-files-between-teams': {
    date: '2026-03-28',
    title: 'Transferring Files between Teams',
    one_line_summary: 'How do I move files from one team to another?',
    categories: [FAQ_CATEGORIES.TEAM, FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION],
  },
  'undo-and-redo-options': {
    date: '2026-03-28',
    title: 'Undo and Redo Options',
    one_line_summary: 'If you would like to undo or redo changes made to your file you can use the “Undo” and “Redo” buttons. To find these navigate to the “Edit” tab.',
    categories: [FAQ_CATEGORIES.SEQUENCE_EDITING],
  },
  'view-options-in-map-view': {
    date: '2026-03-28',
    title: 'View Options in Map View',
    one_line_summary: 'Which options for viewing and displaying are available in map view?',
    categories: [FAQ_CATEGORIES.VIEW_AND_DISPLAY],
  },
  'view-options-in-sequence-view': {
    date: '2026-03-28',
    title: 'View Options in Sequence View',
    one_line_summary: 'Which options for viewing and displaying are available in sequence view?',
    categories: [FAQ_CATEGORIES.VIEW_AND_DISPLAY],
  },
  'virtual-gel-electrophoresis': {
    date: '2026-03-28',
    title: 'Virtual Gel Electrophoresis',
    one_line_summary: 'To simulate gel electrophoresis, navigate to the “PCR” tab in the top banner and select “Virtual Gel”, this will open the gel creation modal box.',
    categories: [FAQ_CATEGORIES.ENZYMES],
  },
  'whats-new-in-version-3-0-39': {
    date: '2026-03-28',
    title: 'Whats New in Version 3_0_39',
    one_line_summary: 'You can now create custom restriction enzymes lists. Navigate to the Enzymes tab, select the drop down and choose “Manage enzymes”. Choose “+ Add group” then select “Edit”. You can give your enzyme group a name and add enzymes to this list. Once finished hit the “Save” button at the top. The new group will be added to the “Enzymes” dropdown menu and you can now display your enzymes on your plasmid.',
    categories: [FAQ_CATEGORIES.WHATS_NEW],
  },
};

/**
 * Lazy-load a guide's HTML fragment. Webpack code-splits each .txt into its
 * own chunk so the main bundle only ships the metadata above.
 */
export function loadGuideHtml(slug: string): Promise<string> {
  // The dynamic import resolves to the fragment file's static URL (CRA emits
  // each .txt to /static/media/...). Fetch the actual content on demand so
  // the main bundle ships zero guide HTML.
  return import(
    /* webpackChunkName: "guide-fragment-url-[request]" */
    `./generated_articles/${slug}.txt`
  )
    .then((m) => fetch((m as { default: string }).default))
    .then((r) => {
      if (!r.ok) throw new Error(`Failed to fetch guide ${slug}: ${r.status}`);
      return r.text();
    });
}

export default articlesData;
